var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsSvgrepoCom = function SvgMetricsSvgrepoCom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.9,2H7.1C4.3,2,2,4.3,2,7.1v37.7C2,47.7,4.3,50,7.1,50h37.7c2.8,0,5.1-2.3,5.1-5.1V7.1 C50,4.3,47.7,2,44.9,2z M15.7,39.7c0,0.9-0.8,1.7-1.7,1.7h-1.7c-0.9,0-1.7-0.8-1.7-1.7v-9.4c0-0.9,0.8-1.7,1.7-1.7H14 c0.9,0,1.7,0.8,1.7,1.7V39.7z M24.3,39.7c0,0.9-0.8,1.7-1.7,1.7h-1.7c-0.9,0-1.7-0.8-1.7-1.7V17.4c0-0.9,0.8-1.7,1.7-1.7h1.7 c0.9,0,1.7,0.8,1.7,1.7V39.7z M32.9,39.7c0,0.9-0.8,1.7-1.7,1.7h-1.7c-0.9,0-1.7-0.8-1.7-1.7V12.3c0-0.9,0.8-1.7,1.7-1.7h1.7 c0.9,0,1.7,0.8,1.7,1.7V39.7z M41.4,39.7c0,0.9-0.8,1.7-1.7,1.7H38c-0.9,0-1.7-0.8-1.7-1.7V23.4c0-0.9,0.8-1.7,1.7-1.7h1.7 c0.9,0,1.7,0.8,1.7,1.7V39.7z"
  }))));
};
export default SvgMetricsSvgrepoCom;